import { useLocation, useHistory } from 'react-router-dom';

export const isEmbedPath = (path) => path.startsWith('/embed');

export const useAppLink = () => {
    const location = useLocation();

    const link = (path) => {
        return path.startsWith('/') && isEmbedPath(location.pathname) ? `/embed${path}` : path;
    };

    return link;
};

export const useAppNavigate = () => {
    const history = useHistory();
    const appLink = useAppLink();
    
    return (path) => {
        console.log(appLink(path));
        return history.push(appLink(path));
    }
  };
  
  export const getAppLinkPath = (embedPath) => {
    if (embedPath === '/embed') return '/';
    if (embedPath.startsWith('/embed/')) {
      return embedPath.slice('/embed'.length);
    }
    return embedPath;
  };